var React = require('react');

function One (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M-3021.5,176.166c0-38.179,13.648-69.166,48.51-69.166s48.507,30.987,48.507,69.166-13.648,69.167-48.507,69.167S-3021.5,214.346-3021.5,176.166Zm40.947,43.9a13.44,13.44,0,0,0,7.563,2.213c14.571,0,22.685-20.841,22.685-46.11a89.475,89.475,0,0,0-2.4-21.764Zm-15.125-43.9a98.323,98.323,0,0,0,2.213,21.581l27.853-65.479a12.882,12.882,0,0,0-7.378-2.212C-2987.561,130.055-2995.678,150.9-2995.678,176.166Zm121.177,66.4V156.8c-3.136,6.824-10.7,11.988-25.085,11.988V142.044c19-1.844,31.725-17.152,34.492-32.278h19.18v132.8Z","transform":"translate(3022.5 -106)","fill":"rgba(0,0,0,0)","stroke":"#e33b30","strokeMiterlimit":"10","strokeWidth":"2"}));
}

One.defaultProps = {"width":"177.585","height":"140.333","viewBox":"0 0 177.585 140.333"};

module.exports = One;

One.default = One;
